module.exports = __webpack_public_path__ + "static/media/Modern Day Builders Inc. -Notice of Proposal to Issue Compliance Order - April 12, 2024.30951585.pdf";